export default __webpack_public_path__ + "static/media/product-page5.28d8c3a6.png";